import {
  Card,
  CardContent,
  Grid2,
  Typography,
  Box,
  Divider,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import moment from "moment";
import { Field, Form, Formik, FieldProps } from "formik";
import API from "../../../../api/axios";
import { useEffect, useState } from "react";
import { getUser } from "../../../../utils/types";
import DataNotFound from "../../../../shared/DataNotFound/DataNotFound";
import { string } from "yup";
import DataLoader from "../../../../shared/DataLoader/DataLoader";
import { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

// Define the shape of the form's initial values
interface FormValues {
  comment: string;
}

interface QueryTrckerRespond {
  type?: string;
}

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Query Tracker", route: "/admin/query-tracker" },
  { name: "Respond" },
];

const QueryTrackerRespond: React.FC<QueryTrckerRespond> = ({ type }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryData = location?.state?.data || {};
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [queries, setQueries] = useState<any>(null);
  const [response, setResponse] = useState<any>(null);
  const userData = getUser();
  const roleCode = userData?.roles?.role_code;
  const user = userData?.user;
  const { id } = useParams();
  let data = {
    query_id: location?.state?.data?.id,
    queryResponse: true,
    offset: 0,
    limit: -1,
  };

  useEffect(() => {
    getCandidateQuery();
  }, []);

  const getCandidateQuery = async () => {
    setLoading(true);
    try {
      const url: string =
        roleCode === "candidate"
          ? "/query/candidate/my/queries"
          : "/query/get/all";
      const response = await API.post(url, {
        ...data,
        query_id: data?.query_id ?? id,
      });
      setQueries(response?.data?.data[0]);
    } catch (error) {
      // Failed to fetch candidate data
    } finally {
      setLoading(false);
    }
  };

  const sendQueryResponse = async () => {
    setBtnLoading(true);
    const data = {
      query_id: location?.state?.data?.id ?? id,
      message_text: response,
    };

    try {
      await API.post("/query/add/reply", { ...data }).then(() => {
        setBtnLoading(false);
        setResponse("");
      });

      getCandidateQuery();
    } catch (error) {
      // Failed to fetch candidate data
    } finally {
      setBtnLoading(false);
      setResponse("");
    }
  };

  const stripHtmlTags = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, "");

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Respond">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          // onClick={() => {
          //   if (type == "view") {
          //     navigate("/admin/query-tracker/view", { state: location?.state });
          //   } else {
          //     navigate("/admin/query-tracker");
          //   }
          // }}
          onClick={() => {
            navigate(-1);
          }}
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
          {loading ? (
            <Box height={"400px"}>
              <DataLoader />
            </Box>
          ) : (
            <>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Query Title</Typography>
                  <Typography variant="subtitle2">
                    {queries?.title || "NA"}
                  </Typography>
                </Grid2>
                {roleCode !== "candidate" && (
                  <Grid2
                    size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Candidate Name</Typography>
                    <Typography variant="subtitle2">
                      {queries?.user_id
                        ? `${queries.user_id?.first_name || ""} ${
                            queries.user_id?.last_name || ""
                          }`
                        : "NA"}
                    </Typography>
                  </Grid2>
                )}
                <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Position Title</Typography>
                  <Typography variant="subtitle2">
                    {queries?.position_id?.name || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Date Raised</Typography>
                  <Typography variant="subtitle2">
                    {handleDate(queries?.date_created)}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Query Status</Typography>
                  <Typography variant="subtitle2">
                    {queries?.query_status || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={12} marginBottom={4}>
                  <Typography variant="body1">Query Description</Typography>
                  <Typography variant="subtitle2">
                    {queries?.description || "NA"}
                  </Typography>
                </Grid2>
              </Grid2>

              <Box marginTop={2} className="conversation-thread-wrap">
                <Box sx={{ border: "1px solid #E6E7E9", borderRadius: "8px" }}>
                  <Box
                    sx={{
                      padding: { xs: "1rem", sm: "1rem", md: "1rem 2rem" },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.875rem", md: "1.2rem" },
                        color: "#000",
                        fontWeight: 500,
                      }}
                    >
                      Conversation Thread
                    </Typography>
                  </Box>
                  <Divider />
                  <Box
                    sx={{
                      padding: { xs: "1rem", sm: "1rem", md: "1rem 2rem" },
                    }}
                  >
                    <Box
                      sx={{
                        paddingRight: { xs: "1rem", sm: "1rem", md: "2rem" },
                        marginBottom: { xs: "1rem", sm: "1rem", md: "2rem" },
                      }}
                      className="conversation-thread-list"
                    >
                      {queries?.query_responses?.length === 0 ? (
                        <DataNotFound />
                      ) : (
                        <>
                          {queries?.query_responses?.map((res: any) => (
                            <Grid2 size={12} marginBottom={3}>
                              <CardContent
                                sx={{
                                  backgroundColor: `${
                                    user?.id == res?.sender_id?.id
                                      ? "#ffffff"
                                      : "#eaecee"
                                  }`,
                                  borderRadius: "8px",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight={600}
                                    sx={{
                                      fontSize: { xs: "12px", md: "14px" },
                                    }}
                                  >
                                    {res?.sender_id?.first_name || ""}{" "}
                                    {res?.sender_id?.last_name || ""}
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontSize: { xs: "12px", md: "14px" },
                                    }}
                                  >
                                    {moment(res?.date_created).format(
                                      "DD-MMM-YYYY hh:mm A"
                                    )}
                                  </Typography>
                                </Box>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ fontSize: { xs: "12px", md: "14px" } }}
                                >
                                  {res?.message_text || "NA"}
                                </Typography>
                              </CardContent>
                            </Grid2>
                          ))}
                        </>
                      )}
                    </Box>
                    <>
                      {type !== "view" && queries?.query_status == "open" && (
                        <TextField
                          label="Add a comment.."
                          variant="outlined"
                          fullWidth
                          multiline
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#BDB395 !important",
                              },
                              "&:hover fieldset": {
                                borderColor: "#BDB395 !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#BDB395 !important",
                              },
                            },
                          }}
                          rows={4}
                          value={response}
                          onChange={(event: any) => {
                            setResponse(stripHtmlTags(event?.target?.value));
                          }}
                        />
                      )}
                    </>

                    {/* Buttons */}
                    <>
                      {type !== "view" && queries?.query_status == "open" && (
                        <Grid2
                          size={12}
                          display="flex"
                          justifyContent="flex-end"
                          marginTop={5}
                        >
                          <Button
                            variant="secondary"
                            variantType="outlined"
                            label="Cancel"
                            style={{
                              marginRight: "1rem",
                              backgroundColor: "#ffffff",
                            }}
                            onClick={() =>
                              navigate("/admin/query-tracker", {
                                state: {
                                  queryStatusState: location?.state?.queryStatusState,
                                  paginationState: location?.state?.paginationState,
                                },
                              })
                            }
                          />
                          <Button
                            type="submit"
                            variant="secondary"
                            variantType="contained"
                            onClick={sendQueryResponse}
                            label={"Save"}
                            isLoading={btnLoading}
                            disabled={!response}
                          />
                        </Grid2>
                      )}
                    </>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </PageWrapper>
  );
};

export default QueryTrackerRespond;
